import { FC, useContext, useEffect, useMemo, useRef, useState } from "react";
import { InfoContext, MasterContext, UIContext } from "../../../shared/contexts";
import { ColSize, InputFactory, RowSize } from "../../../shared/components";
import { PageHeader } from "../../../shared/components/MainLayout/components";
import { Tab, Tabs } from "@hdi-seguros/web-components.tabs";
import { PolicyOverdueDebtTab } from "./components/PolicyOverdueDebtTab";
import { POLICY_OVERDUE_DEBT_TYPE } from "./interfaces/PolicyOverdueDebtType";
import { DownloadOutlined, FilePdfOutlined } from "@ant-design/icons";
import { DEBIT_REJECTIONS_TABS_KEY_VALUES } from "./enums/policy-overdue-debt-tabs-types-enum";

interface PolicyOverdueDebtListProps {
    title: string;
}

export const PolicyOverdueDebtListPage: FC<PolicyOverdueDebtListProps> = ({ title }) => {
    const { setTitle } = useContext(InfoContext);
    const [ activeTab, setActiveTab ] = useState(DEBIT_REJECTIONS_TABS_KEY_VALUES.POLICIES_WITH_OVERDUE_DEBT.toString());
    const handlePressTab = (activeTab: string) => setActiveTab(activeTab);
    const childRef1 = useRef<{ downloadExcel: () => void, downloadPDF: () => void }>(null);
    const childRef2 = useRef<{ downloadExcel: () => void, downloadPDF: () => void }>(null);
    
    const TABS: Array<Tab> = useMemo(() => [
        {
            label: 'Pólizas Vencidas',
            children:<PolicyOverdueDebtTab ref={childRef1} type={POLICY_OVERDUE_DEBT_TYPE.VENCIDAS}/>,
            key: DEBIT_REJECTIONS_TABS_KEY_VALUES.POLICIES_WITH_OVERDUE_DEBT,
            closable: false,
        },
        {
            label: 'Todas',
            children:<PolicyOverdueDebtTab ref={childRef2} type={POLICY_OVERDUE_DEBT_TYPE.TODAS}/>,
            key: DEBIT_REJECTIONS_TABS_KEY_VALUES.POLICIES_ALL,
            closable: false,
        }
    ], []);

    useEffect(() => {
        setTitle(title);
    }, [])

    const handleDownloadExcel = () => {        
        if (activeTab === DEBIT_REJECTIONS_TABS_KEY_VALUES.POLICIES_WITH_OVERDUE_DEBT && childRef1.current) {
            childRef1.current.downloadExcel();
        } else if (activeTab === DEBIT_REJECTIONS_TABS_KEY_VALUES.POLICIES_ALL && childRef2.current) {
            childRef2.current.downloadExcel();
        }
    };

    const handleDownloadPDF = () => {
        if (activeTab === DEBIT_REJECTIONS_TABS_KEY_VALUES.POLICIES_WITH_OVERDUE_DEBT && childRef1.current) {
            childRef1.current.downloadPDF();
        } else if (activeTab === DEBIT_REJECTIONS_TABS_KEY_VALUES.POLICIES_ALL && childRef2.current) {
            childRef2.current.downloadPDF();
        }
    };


    const actions = useMemo(
        () => [
            {
                label: 'Descargar Excel',
                icon: <DownloadOutlined />,
                onClick: handleDownloadExcel,
            },
            {
                label: 'Descargar PDF',
                icon: <FilePdfOutlined />,
                onClick: handleDownloadPDF,
            },
        ],
        [handleDownloadExcel, handleDownloadPDF, activeTab]
    );

    return (
        <>
            <PageHeader actions={actions} />
            <RowSize>
                <ColSize size={100}>
                        <Tabs 
                            onChange={(key) => setActiveTab(key)}
                            handlePressTab={ handlePressTab }
                            activeKey={activeTab}
                            items={ TABS }
                        />
                </ColSize>
            </RowSize>
        </>
    )
}